// ══════════════════════════════════════════════════════════════
// COMPASS – Client consent evidence (US-015)
// ══════════════════════════════════════════════════════════════

/** The backend's rules for any process document (DocumentService), the consent evidence's too. */
export const CONSENT_EVIDENCE_ACCEPTED_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'application/zip'];
export const CONSENT_EVIDENCE_MAX_SIZE_BYTES = 10 * 1024 * 1024;

/** Refused: the signature can no longer be skipped (completed, signed or skipped elsewhere), so neither can the
 *  evidence change. */
export const CONSENT_EVIDENCE_LOCKED = 'error.kyc.signature.consent-evidence-locked';
